import * as React from "react";
import { useState } from "react";
import {
  Box,
  Divider,
  IconButton,
  Stack,
  Text,
  TextField,
} from "@origin-digital/ods-core";
import { SvgIcon } from "@origin-digital/ods-icons";
import AddressDialog from "./AddressDialog";
import { IFormProps } from "../FormAccordionContainer";
import { useFormikContext } from "formik";
import { FormValues } from "../types";
import { generateAddressString } from "../helper";
import FormContext from "src/context/FormContext";

interface AddressFieldProps extends IFormProps {
  isReadOnly: boolean;
}

const AddressField = (props: AddressFieldProps) => {
  const [dialogOpen, setDialog] = useState(false);
  const { setFieldValue, isReadOnly } = props;
  const { values, errors } = useFormikContext<FormValues>();
  const {
    formState: { address },
  } = React.useContext(FormContext);

  return isReadOnly ? (
    <Stack space="xsmall">
      <Stack space="xxsmall">
        <Text variant="body-small" tone="neutralLight">
          Address
        </Text>
        <Text>{address}</Text>
      </Stack>
      <Divider />
    </Stack>
  ) : (
    <>
      <TextField
        id="address"
        label="Address"
        variant="outlined"
        // disabled={true}
        value={
          generateAddressString(values.premiseAddress)
            ? generateAddressString(values.premiseAddress)
            : ""
        }
        hideHelperTextSpace={true}
        helperText={errors?.premiseAddressString}
        error={!!errors?.premiseAddressString}
        endIcon={
          <Box display="flex">
            <IconButton
              data-id="address-dialog-button"
              noIconPadding
              onClick={() => {
                setDialog(true);
              }}
            >
              <SvgIcon color="neutral">
                <path d="M4 21C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20V17.575C3 17.3083 3.05 17.0542 3.15 16.8125C3.25 16.5708 3.39167 16.3583 3.575 16.175L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.825 20.425C7.64167 20.6083 7.42917 20.75 7.1875 20.85C6.94583 20.95 6.69167 21 6.425 21H4ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z" />
              </SvgIcon>
            </IconButton>
            {/* If error or validated, show icon here */}
          </Box>
        }
      />

      <AddressDialog
        open={dialogOpen}
        setDialog={setDialog}
        setFieldValue={setFieldValue}
      />
    </>
  );
};

export default AddressField;
